import { Button, Grid, Typography } from "@mui/material";
import { useState } from "react";
import EditLaskutus from "../../../../../components/laskutus/EditLaskutus";
import PropTypes from "prop-types";
import MySkeleton from "src/components/layout/MySkeleton";
import IconsContainer from "src/components/icons/others/IconsContainer";

export default function LaskuRow(props) {
  const keikkaData = props.keikkaData;
  const [isEditorOpen, setIsEditorOpen] = useState(false);
  const betoniToimittajaNimi = keikkaData.betoniToimittaja.asiakasNimi;
  const pumppuToimittajaNimi = keikkaData.pumppuToimittaja.asiakasNimi;
  const asiakasNimi = keikkaData.asiakas.asiakasNimi;

  const openLaskutusEditorModal = () => {
    setIsEditorOpen(true);
  };
  return (
    <>
      <EditLaskutus
        open={isEditorOpen}
        closeModal={() => setIsEditorOpen(false)}
        keikkaData={keikkaData}
        setKeikkaData={() => props.setKeikkaData(keikkaData)}
      />

      <Button
        variant="text"
        fullWidth
        onClick={openLaskutusEditorModal}
        aria-label="Avaa laskutusmodal"
        sx={{ margin: 0, padding: 0 }}>
        <Grid container className="stepRow" sx={{ width: "100%" }}>
          <Grid size={{ xs: 3 }} sx={{ textAlign: "right" }}>
            <Typography
              variant="h6"
              sx={{ paddingRight: "5px", transition: "all 1.5s ease-in-out" }}
              noWrap
              color="primary"
              className="fixPrint">
              Laskutus:
            </Typography>
          </Grid>
          {keikkaData.isLoading ? (
            <MySkeleton height="60px" width="70%" />
          ) : (
            <>
              <Grid size={{ xs: 7 }} sx={{ textAlign: "left", paddingTop: "5px" }}>
                <Typography
                  color="primary"
                  className="fixPrint"
                  varuant="body2"
                  sx={{ transition: "all 1.5s ease-in-out" }}>
                  {LaskutusText()}
                </Typography>
              </Grid>
              <Grid size={{ xs: 2 }} className="frontPageEditIcon">
                <IconsContainer showEdit={props.keikkaData.auth.edit} editOpacity={0.5} />
              </Grid>
            </>
          )}
        </Grid>
      </Button>
    </>
  );

  function LaskutusText() {
    const l = keikkaData.laskutus;
    let betoniLaskutus = "";
    let pumppuLaskutus = "";
    if (l.isBetoniSuoraLaskutus) {
      betoniLaskutus = betoniToimittajaNimi + " laskuttaa " + asiakasNimi + ":ta betonista";
      if (!l.isPumppuSuoraLaskutus) betoniLaskutus += " ja pumppauksesta";
    } else {
      betoniLaskutus =
        betoniToimittajaNimi + " laskuttaa " + pumppuToimittajaNimi + ":ta betonista";
    }
    if (l.isPumppuSuoraLaskutus) {
      pumppuLaskutus = pumppuToimittajaNimi + " laskuttaa " + asiakasNimi + ":ta pumppauksesta";
      if (!l.isBetoniSuoraLaskutus) pumppuLaskutus += " ja betonista";
    } else {
      pumppuLaskutus =
        pumppuToimittajaNimi + " laskuttaa " + betoniToimittajaNimi + ":ta pumppauksesta";
    }
    return (
      <>
        {keikkaData.modules.hasBetoni && betoniLaskutus + "."}
        {keikkaData.modules.hasBetoni && keikkaData.modules.hasPumppu && <br />}
        {keikkaData.modules.hasPumppu && pumppuLaskutus + "."}
      </>
    );
  }
}

LaskuRow.propTypes = {
  keikkaData: PropTypes.object,
  setKeikkaData: PropTypes.func,
};
